import { Moon, Sun } from 'lucide-react';

// Round sun/moon button for the website nav bars. Shows the mode you would switch to.
export default function ThemeToggle({ isDark, onToggle, color, border, size = 38 }) {
  const label = isDark ? 'Switch to light mode' : 'Switch to dark mode';
  return (
    <button
      type="button"
      onClick={onToggle}
      aria-label={label}
      title={label}
      style={{
        width: size, height: size, flexShrink: 0, padding: 0, borderRadius: '50%',
        display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
        background: 'transparent', border: `1px solid ${border}`, color, cursor: 'pointer',
      }}
    >
      {isDark ? <Sun size={18} /> : <Moon size={18} />}
    </button>
  );
}
